import { typeColors as cTypeColors, subTypeColors as cSubTypeColors, typeUnderline as cTypeUnderline, black as cBlack } from './Constants.js';
export default {
  type: 'TokenStylizer.basic',
  stylize(stylizerSettings, {
    editor
  }) {
    const {
      typeColors = cTypeColors,
      subTypeColors = cSubTypeColors,
      typeUnderline = cTypeUnderline,
      black = cBlack
    } = stylizerSettings;
    return {
      run: tokens => {
        const selection = editor.view.state.selection;
        const editorText = editor.getText();
        editor.chain().setTextSelection({
          from: 1,
          to: editorText.length + 1
        }).setColor(black).unsetUnderline().run();
        tokens.forEach(token => {
          const {
            type,
            subType,
            startIndex,
            endIndex
          } = token;
          const color = subTypeColors[type]?.[subType] || typeColors[type] || black;
          const underline = typeUnderline[type];
          let chain = editor.chain().setTextSelection({
            from: startIndex + 1,
            to: endIndex + 1
          }).setColor(color);
          if (underline) {
            chain = chain.setUnderline(underline);
          } else {
            chain = chain.unsetUnderline();
          }
          chain.run();
        });
        editor.commands.setTextSelection({
          from: selection.from,
          to: selection.to
        });
        editor.commands.setColor(black);
      }
    };
  }
};